import React from 'react';

import { KnowledgeDetailBody, KnowledgeDetailComponents } from './body';

// SSR専用のeager import版。index.tsx（CSR、lazy()+Suspense）と実際の画面構造は
// body.tsxを共有していて、ここでの差分は「lazy()ではなく静的importで解決する」ことだけ。
// registrations/knowledge.js（server-bundle.js経由でのみ読み込まれる）からのみ参照する。
//
// なぜ必要か: react-dom 17.0.2 cjs/react-dom-server.browser.development.js:3838-3847の
// `case REACT_SUSPENSE_TYPE` は、中身がlazy()の未解決Promiseかどうかに関わらず
// <Suspense>要素そのものに遭遇した時点で無条件にthrowする（「ReactDOMServer does not yet
// support Suspense.」= React error #294、実測で確認。当初「未解決のlazy()子がある場合のみ
// throwする」と誤って理解しており、その前提で書いたコメントを本コミットで訂正した）。
// KnowledgeDetail/index.tsxは記事本文52件を含む全ての子をlazy()で読み込んでおり、記事
// コンポーネント自身も内部にHeading2/Heading3用のlazy()+Suspenseを持っていたため、
// courses/PR #2082のDetail/List（内部にlazy()を持たない）向けの
// 「トップレベルだけeager importでMap登録を上書きする」対策では内部のSuspenseが
// 解消できなかった。加えてfooter_inquiry/view.tsx・KnowledgePagger・
// Knowledge/components/knowledge.tsx・faq.tsxは中身がlazy()でない（コード分割の意図が
// ない）にもかかわらず<Suspense fallback={''}>で包んでおり、これも上記の無条件throwに
// より単独でSSRを失敗させていた。記事52件のlazy()除去とこれら中身のないSuspense
// ラッパーの除去の両方を行って初めてSSRが成功する（issue #2141、実測で確認）。
//
// バンドルサイズについて: このファイルはpacks/knowledge.js（prerender_enabled時のみ読み込まれる
// クライアントエントリ）からも共有される（packs/knowledge.jsのコメント参照。React 17の
// ReactDOM.hydrateはSuspenseで中断されたツリーをhydrateできないため、クライアント側も
// このeager版を使う必要がある）。そのため記事52件分のコード（yarn build時点で
// 合計424KB、gzip後は数十KB程度）が/knowledge/:id訪問時に一括で読み込まれるようになり、
// 従来の記事単位のコード分割（1/52件のみ読み込み）より増加する。会員権の基礎知識記事は
// 表示専用の静的コンテンツで動画等の重いアセットを含まないため許容範囲と判断したが、
// 実際のバンドルサイズは`yarn build`後にpublic/packs/knowledge-*.jsで確認すること。
import Breadcrumb from '@Components/breadcrumb/view';
import FooterInquiryPC from '@Components/pc/footer_inquiry/view';
import FooterInquirySP from '@Components/sp/footer_inquiry/view';
import PagePC from '@Components/pc/page/view';
import PageSP from '@Components/sp/page/view';
import Heading1 from '@Components/heading_1/view';
import KnowledgePagger from './components/KnowledgePagger/index';
import Knowledge1 from './components/Knowledge1';
import Knowledge2 from './components/Knowledge2';
import Knowledge3 from './components/Knowledge3';
import Knowledge4 from './components/Knowledge4';
import Knowledge5 from './components/Knowledge5';
import Knowledge6 from './components/Knowledge6';
import Knowledge7 from './components/Knowledge7';
import Knowledge8 from './components/Knowledge8';
import Knowledge9 from './components/Knowledge9';
import Knowledge10 from './components/Knowledge10';
import Knowledge11 from './components/Knowledge11';
import Knowledge12 from './components/Knowledge12';
import Knowledge13 from './components/Knowledge13';
import Knowledge14 from './components/Knowledge14';
import Knowledge15 from './components/Knowledge15';
import Knowledge16 from './components/Knowledge16';
import Knowledge17 from './components/Knowledge17';
import Knowledge18 from './components/Knowledge18';
import Knowledge19 from './components/Knowledge19';
import Knowledge20 from './components/Knowledge20';
import Knowledge21 from './components/Knowledge21';
import Knowledge22 from './components/Knowledge22';
import Knowledge23 from './components/Knowledge23';
import Knowledge24 from './components/Knowledge24';
import Knowledge25 from './components/Knowledge25';
import Knowledge26 from './components/Knowledge26';
import Knowledge27 from './components/Knowledge27';
import Knowledge28 from './components/Knowledge28';
import Knowledge29 from './components/Knowledge29';
import Knowledge30 from './components/Knowledge30';
import Knowledge31 from './components/Knowledge31';
import Knowledge32 from './components/Knowledge32';
import Knowledge33 from './components/Knowledge33';
import Knowledge34 from './components/Knowledge34';
import Knowledge35 from './components/Knowledge35';
import Knowledge36 from './components/Knowledge36';
import Knowledge37 from './components/Knowledge37';
import Knowledge38 from './components/Knowledge38';
import Knowledge39 from './components/Knowledge39';
import Knowledge40 from './components/Knowledge40';
import Knowledge41 from './components/Knowledge41';
import Knowledge42 from './components/Knowledge42';
import Knowledge43 from './components/Knowledge43';
import Knowledge44 from './components/Knowledge44';
import Knowledge45 from './components/Knowledge45';
import Knowledge50 from './components/Knowledge50';
import Knowledge51 from './components/Knowledge51';
import Knowledge52 from './components/Knowledge52';
import Knowledge53 from './components/Knowledge53';
import Knowledge54 from './components/Knowledge54';
import Knowledge55 from './components/Knowledge55';
import Knowledge56 from './components/Knowledge56';

const articles = {
    1: Knowledge1,
    2: Knowledge2,
    3: Knowledge3,
    4: Knowledge4,
    5: Knowledge5,
    6: Knowledge6,
    7: Knowledge7,
    8: Knowledge8,
    9: Knowledge9,
    10: Knowledge10,
    11: Knowledge11,
    12: Knowledge12,
    13: Knowledge13,
    14: Knowledge14,
    15: Knowledge15,
    16: Knowledge16,
    17: Knowledge17,
    18: Knowledge18,
    19: Knowledge19,
    20: Knowledge20,
    21: Knowledge21,
    22: Knowledge22,
    23: Knowledge23,
    24: Knowledge24,
    25: Knowledge25,
    26: Knowledge26,
    27: Knowledge27,
    28: Knowledge28,
    29: Knowledge29,
    30: Knowledge30,
    31: Knowledge31,
    32: Knowledge32,
    33: Knowledge33,
    34: Knowledge34,
    35: Knowledge35,
    36: Knowledge36,
    37: Knowledge37,
    38: Knowledge38,
    39: Knowledge39,
    40: Knowledge40,
    41: Knowledge41,
    42: Knowledge42,
    43: Knowledge43,
    44: Knowledge44,
    45: Knowledge45,
    50: Knowledge50,
    51: Knowledge51,
    52: Knowledge52,
    53: Knowledge53,
    54: Knowledge54,
    55: Knowledge55,
    56: Knowledge56,
};

const components: KnowledgeDetailComponents = {
    Breadcrumb,
    FooterInquiryPC,
    FooterInquirySP,
    PagePC,
    PageSP,
    Heading1,
    KnowledgePagger,
    articles,
};

type KnowledgeDetailProps = {
    id: number;
    isSp: boolean;
    h1Override?: string | null;
    currentPath?: string;
};

const KnowledgeDetail = (props: KnowledgeDetailProps) => {
    return <KnowledgeDetailBody {...props} components={components} />;
};

export default KnowledgeDetail;
